import wixData from 'wix-data';

export function button2_click(event, $w) {
	$w('#dataset1').setFilter(wixData.filter()
			.contains("style", $w('#haim1').value)
			.contains("pepoleFilter", $w('#haim2').value)

		)
		.then(() => {
			if ($w('#dataset1').getTotalCount() === 0) {
				$w('#txtNoResults').show();
			} else {
				$w('#txtNoResults').hide()
			}
		})

	$w('#repeater1').expand();
}

export function button3_click(event, $W) {
	//Add your code for this event here: 
	$w("#dataset1").setFilter(wixData.filter())
		.then(() => {
			if ($w('#dataset1').getTotalCount() === 0) {
				$w('#txtNoResults').show();
			} else {
				$w('#txtNoResults').hide()
			}
		})
}

export function searchbarbutton_click(event, $w) {
	$w('#dataset1').setFilter(wixData.filter()
			.contains("title", $w('#SearchBar').value)

		)
		.then(() => {
			if ($w('#dataset1').getTotalCount() === 0) {
				$w('#txtNoResults').show();
			} else {
				$w('#txtNoResults').hide()
			}
		})

	$w('#repeater1').expand();
}

export function haim3(event) {
	//Add your code for this event here: 
}

import { local } from 'wix-storage';

import wixLocation from 'wix-location';

$w.onReady(function () {

});

export function searchbarbutton_click_1(event) {
	//Add your code for this event here: 
}

export function searchbarbutton_click_2(event) {
	//Add your code for this event here: 
}